var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-progress-circular',{staticClass:"wgu-maploading-status",attrs:{"value":80,"indeterminate":"","color":"secondary"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }